import jsPDF from "jspdf";

import {autoTable} from "jspdf-autotable";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {printFormatNumber, sF} from "../utilities/NumberFormatter";


export function CashBookPrint(body, name, dates) {


    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });
    let foot = ["Cash:", 0,  "Cheques:", 0, "Post", 0,"-"]
    let bList = []
    body.forEach(element => {
        const b = [
            element.invoiceId,
            element.instrument,
            element.customerName,
            element.debit.toLocaleString(),
            element.credit.toLocaleString(),
            element.departmentName,
            element.comment.trim()
        ]
        foot[1] += element.instrument === "CASH" ? (sF(element.credit) - sF(element.debit)) : 0
        foot[3] += element.instrument === "CHEQUE" ? (sF(element.credit) - sF(element.debit)) : 0
        foot[5] += element.instrument === "POST" ? (sF(element.credit) - sF(element.debit)) : 0
        bList = [...bList, b]

    })

    const heading = ['Id', 'Instrument', 'Customer', 'Debit', 'Credit','Department', 'Comment'];
    let y = 10
    doc.setFontSize(8);
    doc.text(name, 20, y = y + 30,);
    doc.text("Cash Book ", 300, 40)
    doc.text(`Date: ${dates}`, 300, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
            bodyStyles: {fontSize: 8, cellWidth: "auto"},
            showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),
            foot: [foot.map(item => {
                return item.toLocaleString()
            })],

            columnStyles: {
                0: {halign: "Left"},
                1: {halign: "left"},
                2: {halign: "left"},
                3: {halign: "right"},
                4: {halign: "right"},
                5: {halign: "left"},
                6: {halign: "left"}
            },
        }
    )
    doc.save(`CashBook-${ToBritishDate(dates)}.pdf`);
}

